module.exports = __webpack_public_path__ + "static/media/IMG_7082.12da4efe.jpg";